import { Link, Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import SandboxLogo from '../../assets/images/sandbox-footer-logo.svg';
import { PATHS } from '../../routing/routes';

export const Footer = () => {
  const urls: string[][] = [
    [PATHS.ACCESSIBILITY_STATEMENT, t('footer.a11yStatement')],
    [PATHS.USE_CONDITIONS_STATEMENT, t('footer.useConditions')],
  ];

  const currentYear = new Date().getFullYear();

  return (
    <Stack sx={{ px: 3, py: 2 }} direction={{ md: 'row', xs: 'column' }} justifyContent="space-between" gap={2} component="footer">
      <Typography variant="body2">
        <SandboxLogo style={{ verticalAlign: 'bottom', marginRight: '0.5rem' }} title={t('a11y.footer.logo')} /> {t('footer.company', { year: currentYear })}
      </Typography>
      <Stack
        direction={{ md: 'row', xs: 'column' }}
        justifyContent="end"
        alignItems={{ md: 'center', xs: 'start' }}
        flexWrap="wrap"
        columnGap={3.75}
        rowGap={0.75}
      >
        {urls.map(([url, label], idx) => (
          <Link
            key={idx}
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
            href={url}
          >
            <Typography variant="body2">{label}</Typography>
          </Link>
        ))}
      </Stack>
    </Stack>
  );
};
